import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CabecalhoProtocolo, RateioDespesas, TipoDocumento, TipoDespesa, EmpresaMRV, DivisaoEmpresa, AprovadorSLD, Fornecedor, DocumentoPreEditadoRtn, SaldoAdiantamento,  IAprovadorSLDResponse, User } from '../../_models';
import { EmpresaMRVService, AprovadorSLDService, FornecedorService } from '../../_services';
import { TipoService } from 'src/app/_services/tipo.service';
import {NaoFiscalService} from 'src/app/_services/naoFiscal.service';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';
import { PopupAdiantamentosComponent } from '../popup-adiantamentos/popup-adiantamentos.component';
import { ConfirmacaoProtocoloComponent } from '../confirmacaoProtocolo/confirmacaoProtocolo.component';
import { DocumentoPreEditado } from '../../_models/DocumentoPreEditado';
import { Message } from '../../_models/Message';
import { DocumentoPreEditadoService } from '../../_services/DocumentoPreEditado.service';
import { UploadUCMService } from '../../_services/uploadUCM.service';
import { AppComponent } from '../../app.component';
import { ActivatedRoute, Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { MaskService } from 'src/app/_services/mask.service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { ProtocoloComponent } from '../protocolo/protocolo.component';
import { PopupMessagesNewStyleTestComponent } from '../popup-messages-new-style-test/popup-messages-new-style-test.component';

@Component({
  selector: 'app-adiantamento',
  templateUrl: './adiantamento.component.html',
  styleUrls: ['./adiantamento.component.css']
})
export class AdiantamentoComponent implements OnInit {
  @Input() FormDataUpload = new FormData();
  @ViewChild('resetButton', {static: true}) resetButton: ElementRef;
  currentUser: User;

  step = 0;
  constructor(
    private loadComponent: AppComponent,
    private apiValidateEmpMRV: EmpresaMRVService,
    private dateAdapter: DateAdapter<Date>,
    private apiAprovadoresSLD: AprovadorSLDService,
    private apiValidateFornecedor: FornecedorService,
    private formBuildercabecalho: FormBuilder,
    private formItensAdiantamento: FormBuilder,
    private protocoloComponent: ProtocoloComponent,
    private apiTipoDespesa: TipoService,
    private apiDocumentoPreEditado: DocumentoPreEditadoService,
    private apiNaoFiscal: NaoFiscalService,
    private route: ActivatedRoute,
    private router: Router,
    private apiUploadUCM: UploadUCMService,
    private dialog?: MatDialog,
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.dateAdapter.setLocale('pt-br');
    this.mask = new MaskService();
  }

  // Validators
  cabecalhoAdiantamento: FormGroup;
  itensAdiantamentoForm: FormGroup;

  //NgModel
  cabecalhoProtocolo = {} as CabecalhoProtocolo;
  public fornecedor = new Fornecedor();
  public tiposDespesaSelected = new TipoDespesa();
  rateioDespesas = {} as RateioDespesas;
  public protocoloEdicao = new DocumentoPreEditado();
  lstRateioDespesas = new Array<RateioDespesas>();
  public documentoPreEditadoRtn = new DocumentoPreEditadoRtn();

  //Utilities
  mask: MaskService;
  filteredOptions: Observable<IAprovadorSLDResponse>;

  // Models
  public empresaMRV = new EmpresaMRV();

  //API's returns
  public divisoesEmpresa: DivisaoEmpresa[];
  public aprovadoresSLD: AprovadorSLD[];
  public saldosAdiantamentos: SaldoAdiantamento[];
  public tipoDespesas: TipoDespesa[];

  // Screen rules
  loadCNPJs = false;
  carregandoAprovador = false;
  carregandoDivisao = false;
  modoEdicao: boolean;
  messageModel: Message;
  tipoDocSelected = {} as TipoDocumento;
  confirmDocPreEditado: boolean;
  carregarDivisao: string;
  descTipoDespesa: string;

  //Controls Autocomplete
  frmAprovador = new FormControl();
  optionsAprovador: string[];
  filteredOptionsAprovador: Observable<string[]>;

  frmDivisao = new FormControl();
  optionsDivisao: string[];
  filteredOptionsDivisao: Observable<string[]>;

  ngOnInit() {
    this.protocoloComponent.finishLoad();
    this.CarregarValidacoesTela();
    this.CarregarIntegracoes();
    this.getTiposDespesas("13");
    
    let idProtocolo = this.route.snapshot.params['idProtocolo'];
    console.log(idProtocolo)
    if (idProtocolo != undefined){
      this.modoEdicao = true;
      this.carregarDadosProtocolo(idProtocolo);
    }
    else
      this.step = 1;
  }

  carregarDadosProtocolo(protocoloID: string) {
    this.apiDocumentoPreEditado.obterProtocolo(protocoloID)
      .subscribe(
        data => this.protocoloEdicao = data.data,
        err => console.error(err),
        () => {
          if (this.protocoloEdicao != null)
            this.CarregarDadosTela(this.protocoloEdicao)
        }
      )
  }

  CarregarDadosTela(protocolo: DocumentoPreEditado) {
    this.apiTipoDespesa.getTipoDespesas("13").subscribe(
      data => {
        this.tipoDespesas = data.data;
        this.tipoDespesas = this.tipoDespesas.filter(x => x.codDespesa == protocolo.rateios[0].codDespesa);
        this.tiposDespesaSelected.codDespesa = protocolo.rateios[0].codDespesa;
        this.tiposDespesaSelected.contaRazao = this.tipoDespesas.filter(x => x.codDespesa == protocolo.rateios[0].codDespesa)[0].contaRazao;
        this.tiposDespesaSelected.tipoDespesa = this.tipoDespesas.filter(x => x.codDespesa == protocolo.rateios[0].codDespesa)[0].tipoDespesa;
        this.tiposDespesaSelected.tipoDocumento = this.tipoDespesas.filter(x => x.codDespesa == protocolo.rateios[0].codDespesa)[0].tipoDocumento;

        this.descTipoDespesa = protocolo.rateios[0].codDespesa + ' - ' + this.tipoDespesas.filter(x => x.codDespesa == protocolo.rateios[0].codDespesa)[0].tipoDespesa;
      });

    this.loadComponent.startLoading(true);
    this.cabecalhoProtocolo.cnpjEmpresa = protocolo.cnpjDestinatario;
    this.cabecalhoProtocolo.cnpjFornecedor = protocolo.cnpjfornecedor ?? protocolo.cpffornecedor;
    this.carregarDivisao = protocolo.divisao;
    this.rateioDespesas.codDespesa = protocolo.rateios[0].codDespesa;
    this.rateioDespesas.valor = protocolo.rateios[0].valor;
    this.rateioDespesas.descricao = protocolo.rateios[0].descricao;
    
    this.carregarFornecedor();
    this.carregarEmpresaTomador();
    this.apiAprovadoresSLD.ObterAprovadores()
    .subscribe(data => {this.aprovadoresSLD = data.data;
    this.cabecalhoProtocolo.aprovador = this.aprovadoresSLD.filter(x => x.login == protocolo.loginAprovador)[0].nome;
    this.loadComponent.startLoading(false);});

    this.cabecalhoAdiantamento.controls["frmCnpjEmpresa"].disable();
    this.cabecalhoAdiantamento.controls["frmAprovador"].disable();
    this.cabecalhoAdiantamento.controls["frmCnpjFornecedor"].disable();
    this.cabecalhoAdiantamento.controls["frmDivisao"].disable();
    this.cabecalhoAdiantamento.controls["frmTipoDespesa"].disable();
    this.cabecalhoAdiantamento.controls["frmDescTipoDespesa"].disable();
    this.itensAdiantamentoForm.controls["frmValorDespesa"].disable();
    this.itensAdiantamentoForm.controls["frmDescricaoDespesa"].disable();
    this.itensAdiantamentoForm.controls["btSave"].disable();
    this.protocoloComponent.tipoDocumentoForm.controls["frmTipoDoc"].disable();
  }

  CarregarIntegracoes() {
    if (this.modoEdicao)
      this.loadComponent.startLoading(true);

    this.getAprovadoresSLD();
  }

  get f() { return this.cabecalhoAdiantamento.controls; }
  get fItens() { return this.itensAdiantamentoForm.controls; }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  prevStepProtocolo(){
    this.protocoloComponent.step--;
  }

  CarregarValidacoesTela() {
    // VALIDAÇÕES FORMULARIO 2. FICHA DO PROTOCOLO
    this.cabecalhoAdiantamento = this.formBuildercabecalho.group({
      frmCnpjEmpresa: ['', Validators.nullValidator],
      frmNomeEmpresa: ['', Validators.required],
      frmAprovador: ['', Validators.required],
      frmCnpjFornecedor: ['', Validators.required],
      frmNomeFornecedor: ['', Validators.required],
      frmDivisao: ['', Validators.required],
      frmTipoDespesa: ['', Validators.required],
      frmDescTipoDespesa: ['', Validators.nullValidator],
    });

    this.itensAdiantamentoForm = this.formItensAdiantamento.group({
      frmValorDespesa: ['', Validators.required],
      frmDescricaoDespesa: ['', Validators.required]
    });

    this.cabecalhoAdiantamento.controls["frmNomeEmpresa"].disable();
    this.cabecalhoAdiantamento.controls["frmNomeFornecedor"].disable();
  }

  carregarEmpresaTomador() {
    if (this.cabecalhoProtocolo.cnpjEmpresa != "") {
      let re = /[.\-/]/g;
      
      this.cabecalhoProtocolo.cnpjEmpresa = this.cabecalhoProtocolo.cnpjEmpresa.replace(re, '');

      this.loadCNPJs = true;
      this.apiValidateEmpMRV.ObterEmpresaMrv(this.cabecalhoProtocolo.cnpjEmpresa)
        .subscribe(
          data => { this.empresaMRV = data.data },
          err => console.error(err),
          () => {
            if (this.empresaMRV == null)
              this.clearFieldsRelated();
            else {
              this.getDivisaoByEmpresa();
              this.cabecalhoAdiantamento.controls["frmNomeEmpresa"].setValue(this.empresaMRV.descricaoEmp);
            }

            this.loadCNPJs = false;
          });
    }
    else
      this.clearFieldsRelated();
  }

  carregarFornecedor() {
    if (this.cabecalhoProtocolo.cnpjFornecedor != "") {
      let re = /[.\-/]/g;
      this.cabecalhoProtocolo.cnpjFornecedor = this.cabecalhoProtocolo.cnpjFornecedor.replace(re, '');

      this.loadCNPJs = true;
      this.apiValidateFornecedor.ObterFornecedor(this.cabecalhoProtocolo.cnpjFornecedor)
        .subscribe(
          data => { this.fornecedor = data.data },
          err => console.error(err),
          () => {
            this.verificaFornecedor(this.fornecedor);
            this.loadCNPJs = false;
          }
        );
    }
    else
      this.fornecedor = new Fornecedor();
  }

  verificaFornecedor(fornecedor: Fornecedor) {
    if (fornecedor == null || fornecedor.status == "E") {
      this.messageModel = new Message(
        "Fornecedor",
        fornecedor.mensagem,
        "",
        "error");

      this.fornecedor = new Fornecedor();
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    }
    else {
      if(this.protocoloComponent.tipoDocSelected.codTipoDocumento == '04' && fornecedor.codigoGrupoContaFornecedor != 'YCFS') {
        this.messageModel = new Message(
          "Fornecedor",
          "Grupo de fornecedor impedido de criar o tipo de documento Concessionárias.",
          "",
          "error");
  
        this.fornecedor = new Fornecedor();
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      }
      else
        this.cabecalhoAdiantamento.controls["frmNomeFornecedor"].setValue(this.fornecedor.nomeFornecedor);
    }
  }

  onSubmitCabecalho() {
    // stop here if form is invalid
    if(this.aprovadoresSLD.filter(x => x.nome == this.cabecalhoProtocolo.aprovador).length == 0)
      this.cabecalhoProtocolo.aprovador = '';

    if(this.divisoesEmpresa.filter(x => x.cod_descricao == this.cabecalhoProtocolo.divisao).length == 0)
      this.cabecalhoProtocolo.divisao = '';

    if (this.cabecalhoAdiantamento.invalid || 
      this.aprovadoresSLD.filter(x => x.nome == this.cabecalhoProtocolo.aprovador).length == 0|| 
      this.divisoesEmpresa.filter(x => x.cod_descricao == this.cabecalhoProtocolo.divisao).length == 0)
      return;

    else
      this.nextStep();
  }

  VerificaRetornoAdiantamentos(adiantamentos: Array<SaldoAdiantamento>) {
    if (adiantamentos != null && adiantamentos.length > 0) {
      if (adiantamentos.filter(e => e.status == "E").length > 0) {
        this.messageModel = new Message(
          "Adiantamentos",
          adiantamentos[0].mensagem,
          "",
          "error");

        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      }
      else {
        const dialogRef = this.dialog.open(PopupAdiantamentosComponent, { data: adiantamentos });
        dialogRef.afterClosed().subscribe(result => {
        });
      }

    }
  }

  CarregarDadosPreEditado() {
    let docPreEditado = new DocumentoPreEditado();

    if (this.modoEdicao)
      docPreEditado.idProtocolo = this.route.snapshot.params['idProtocolo'];
    else
      docPreEditado.idProtocolo = 0;

    docPreEditado.valor = this.itensAdiantamentoForm.controls['frmValorDespesa'].value;
    docPreEditado.dataEmissaoNf = new Date();
    docPreEditado.dataVencimentoNf = new Date();
    docPreEditado.idTipoDocumento = Number(this.protocoloComponent.tipoDocSelected.codTipoDocumento);
    docPreEditado.descTipoDocumento = this.protocoloComponent.tipoDocSelected.tipoDocumento;
    docPreEditado.tipoDocumentoSap = this.protocoloComponent.tipoDocSelected.tipoDocumentoSap;
    docPreEditado.idStatusProtocolo = 51;
    docPreEditado.idStatusNovo = 1;
    docPreEditado.loginUsuarioCriacao = this.currentUser.login;

    docPreEditado.loginResponsavel = this.currentUser.login;
    docPreEditado.loginUsuarioResponsavel = this.currentUser.login;
    docPreEditado.emailUsuarioResponsavel = this.currentUser.email;
    if (this.modoEdicao)
      docPreEditado.dataHoraCriacao = this.protocoloEdicao.dataHoraCriacao;
    else
      docPreEditado.dataHoraCriacao = new Date();

    docPreEditado.dataHoraAlteracao = new Date();
    docPreEditado.loginUsuarioUltAlteracao = this.currentUser.login;
    docPreEditado.nomeFornecedor = this.cabecalhoProtocolo.nomeFornecedor;
    docPreEditado.cnpjfornecedor = this.fornecedor.cnpjFornecedor;
    docPreEditado.cpffornecedor = '';
    docPreEditado.cnpjDestinatario = this.cabecalhoProtocolo.cnpjEmpresa;
    docPreEditado.nomeEmpresa = this.cabecalhoProtocolo.nomeEmpresa;
    docPreEditado.loginAprovador = this.aprovadoresSLD.filter(x => x.nome == this.cabecalhoProtocolo.aprovador)[0].login;
    docPreEditado.observacao = '';
    docPreEditado.quantidadeRateio = 1;
    docPreEditado.condicaoPagamento = '';
    docPreEditado.parcelado = false;
    docPreEditado.codDespesa = this.tiposDespesaSelected.codDespesa;
    docPreEditado.codBarras = '';
    docPreEditado.divisao = this.divisoesEmpresa.filter(x => x.cod_descricao == this.cabecalhoProtocolo.divisao)[0].codigoDiv;
    docPreEditado.codEmpresa = this.empresaMRV.codigoEmp;
    docPreEditado.idSapFornecedor = this.fornecedor.codigoFornecedor;

    this.tiposDespesaSelected = this.cabecalhoAdiantamento.controls['frmTipoDespesa'].value;
    this.rateioDespesas.codDespesa = this.tiposDespesaSelected.codDespesa;
    this.rateioDespesas.nomeTipoDespesa = this.tiposDespesaSelected.tipoDespesa;
    this.rateioDespesas.contaRazao = this.tiposDespesaSelected.contaRazao;
    this.rateioDespesas.usuarioAlteracao = this.currentUser.login;
    this.rateioDespesas.usuarioCadastro = this.currentUser.login;
    this.rateioDespesas.valor = Number(this.itensAdiantamentoForm.controls['frmValorDespesa'].value.toFixed(5));
    this.rateioDespesas.descricao = this.itensAdiantamentoForm.controls['frmDescricaoDespesa'].value;
    this.rateioDespesas.identificacaoColetor = '';
    this.rateioDespesas.codTipoColetor = '';

    this.lstRateioDespesas.push(this.rateioDespesas);

    docPreEditado.rateios = this.lstRateioDespesas;

    if (this.cabecalhoProtocolo.imagens != null && this.cabecalhoProtocolo.imagens.length > 0)
      docPreEditado.imagensNotaFiscal = this.cabecalhoProtocolo.imagens;

    return docPreEditado;
  }

  Salvar() {

    if (!this.ValidacoesSalvar() || this.modoEdicao)
      return;

    let docPreEditado = this.CarregarDadosPreEditado();
    console.log(docPreEditado)

    //Validação de perfil
    
    if (this.currentUser.login != docPreEditado.loginResponsavel
      && !this.currentUser.movimentarProtocoloTerceiros) {
      this.messageModel = new Message("Atenção", "Seu usuário não possui acesso para modificação de protocolos de terceiros", "", "warning");

      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return;
    }

    //Validação de status
    if (this.modoEdicao) {
      if (this.protocoloEdicao.idStatusNovo == 9) {
        this.messageModel = new Message("Atenção", "Documento já cancelado, não é possível executar operação", "", "warning");
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }

      if (this.protocoloEdicao.idStatusNovo != 1 && this.protocoloEdicao.idStatusNovo != 4 && this.protocoloEdicao.idStatusNovo != 9) {
        this.messageModel = new Message("Atenção", "Documento já aprovado, não é possível editar", "", "warning");
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }
    }

    //Confirmar gravação
    const dialogRef = this.dialog.open(ConfirmacaoProtocoloComponent, { data: docPreEditado });

    dialogRef.afterClosed().subscribe(result => {
      this.confirmDocPreEditado = result;

      // Verificar duplicidade na base e grava o protocolo
      if (this.confirmDocPreEditado != null && this.confirmDocPreEditado) {
        this.loadComponent.startLoading(true);
        this.VerificaDuplicidade(docPreEditado);
      }
    });
  }

  VerificaDuplicidade(docPreEditado: DocumentoPreEditado) {
    let confirmaGravacaoDuplicidade = false;
    let rtn: DocumentoPreEditadoRtn;

    this.apiNaoFiscal.VerificaDuplicidadeNaoFiscal(docPreEditado)
      .subscribe(
        data => {
          rtn = data.data;

          if (rtn?.success) {
            this.messageModel = new Message("Atenção",
              "Já existe um protocolo com esse fornecedor, valor, divisão e tipo de documento para o mês corrente. Deseja prosseguir?", "", "confirm");
            const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
            dialogRef.afterClosed().subscribe(result => {
              confirmaGravacaoDuplicidade = result

              //Caso haja a confirmação dos dados pre-editados e a confirmação de gravar em duplicidade é criado o protocolo
              if (confirmaGravacaoDuplicidade)
                this.CriarProtocolo(docPreEditado);
              else
                this.loadComponent.startLoading(false);
            });
          }
          else
            this.CriarProtocolo(docPreEditado);
        });;
  }

  CriarProtocolo(docPreEditado: DocumentoPreEditado) {
    this.FormDataUpload.delete("DocumentoPreEditado");
    this.FormDataUpload.append("DocumentoPreEditado", JSON.stringify(docPreEditado));

    this.protocoloComponent.FormDataUpload.delete("DocumentoPreEditado");
    this.protocoloComponent.FormDataUpload.append("DocumentoPreEditado", JSON.stringify(docPreEditado));

    if (!this.modoEdicao) {
      this.apiDocumentoPreEditado.CriarDocumentoAdiantamento(this.protocoloComponent.FormDataUpload)
        .subscribe(
          rtn => this.documentoPreEditadoRtn = rtn.data.result,
          err => {
            this.loadComponent.startLoading(false);
            console.error(err);
          },
          () => {
            if (this.documentoPreEditadoRtn != null)
              this.VerificaRetornoDocumento(this.documentoPreEditadoRtn);
          });
    }
  }

  VerificaRetornoDocumento(documento: DocumentoPreEditadoRtn) {
    this.loadComponent.startLoading(true);
    if (documento.success) {
      let docPreEditado = this.CarregarDadosPreEditado();
      docPreEditado.idProtocolo = documento.data.idProtocolo;
      docPreEditado.documento = documento.data.documento;

      if(this.protocoloComponent.LstUploadFiles.length > 0)
        this.uploadFiles(docPreEditado);
      else{
        this.ExibeMensagemSucessoProtocolo(docPreEditado.idProtocolo, docPreEditado.documento);
        this.loadComponent.startLoading(false);
      }
    }
    else {
      this.messageModel = new Message(
        "Ocorreu um problema ao criar o documento pré-editado no SAP",
        documento.message,
        "",
        "error");

      this.loadComponent.startLoading(false);
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    }
  }

  uploadFiles(documento: DocumentoPreEditado) {
    let temp;
    this.protocoloComponent.FormDataUpload.delete("DocumentoPreEditadoUpload");
    this.protocoloComponent.FormDataUpload.append("DocumentoPreEditadoUpload", JSON.stringify(documento));

    this.apiUploadUCM.upload(this.protocoloComponent.FormDataUpload)
      .subscribe(
        rtn => temp = rtn,
        err => { console.error(err); this.loadComponent.startLoading(false); },
        () => {
          if (!temp?.data?.success)
            this.ExibeMensagemUpload("Erro ao enviar as imagens para o UCM. Tente novamente.", temp.data.message);
          else
            this.ExibeMensagemSucessoProtocolo(documento.idProtocolo, documento.documento);

          this.loadComponent.startLoading(false);
        });
  }

  ExibeMensagemUpload(title: string, message: string, status: string = null) {
    this.messageModel = new Message(title, "", `Detalhes: ${message} `, status);

    this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
  }

  ExibeMensagemSucessoProtocolo(idProtocolo: number, documento: string) {
    let title = "Item processado com sucesso";
    let message = `N° Protocolo: ${idProtocolo} - N° Pedido Não Fiscal: ${documento}`;
    this.messageModel = new Message(title, "", `Detalhes: ${message} `, 'success');
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    dialogRef.afterClosed().subscribe(r => {
      this.router.navigate(['/home']);
    });
  }

  ValidacoesSalvar() {

    // Validação de campos obrigatórios
    if (this.cabecalhoAdiantamento.invalid || this.itensAdiantamentoForm.invalid) {
      return false;
    }
    
    // Valores divergentes para o rateio
    if (this.itensAdiantamentoForm.controls['frmValorDespesa'] == null || 
    Number(this.itensAdiantamentoForm.controls['frmValorDespesa'].value.toFixed(5)) <= 0) {
      this.messageModel = new Message("Atenção", "Verifique o valor do item de adiantamento", "", "warning");

      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return false;
    }

    return true;
  }

  getTiposDespesas(tipoDoc: string) {
    this.apiTipoDespesa.getTipoDespesas(tipoDoc).subscribe(
      data => {
        this.tipoDespesas = data.data;
      });
  }

  getAprovadoresSLD() {
    this.carregandoAprovador = true;

    this.apiAprovadoresSLD.ObterAprovadores()
      .subscribe(
        data => {
          this.aprovadoresSLD = data.data;

          this.optionsAprovador = this.aprovadoresSLD.map(({ nome }) => nome);
          this.filteredOptionsAprovador = this.frmAprovador.valueChanges
          .pipe(
            startWith(''),
            map(value => this._filterAprovador(value))
          );

          this.carregandoAprovador = false;
        });
  }

  private _filterAprovador(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.optionsAprovador.filter(option => option.toLowerCase().includes(filterValue));
  }

  clearFieldsRelated() {
    this.empresaMRV = new EmpresaMRV();
    this.divisoesEmpresa = new Array<DivisaoEmpresa>();
  }

  getDivisaoByEmpresa() {
    this.carregandoDivisao = true;

    this.apiValidateEmpMRV.ObterDivisoesEmpresaMrv(this.empresaMRV.cnpjEmp, this.empresaMRV.codFil)
      .subscribe(data => {this.divisoesEmpresa = data.data;
        this.optionsDivisao = this.divisoesEmpresa.map(({ cod_descricao }) => cod_descricao);
        this.filteredOptionsDivisao = this.frmDivisao.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterDivisao(value))
        );
        this.carregandoDivisao = false;

        if(this.carregarDivisao != '')
          this.cabecalhoProtocolo.divisao = this.divisoesEmpresa.filter(x => x.codigoDiv == this.carregarDivisao)[0].cod_descricao;
      });
  }

  private _filterDivisao(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.optionsDivisao.filter(x => x.toLowerCase().includes(filterValue));
  }

  getErrorCNPJMessage() {
    if (this.f.frmCnpjEmpresa.hasError('minlength') ||
      this.f.frmCnpjFornecedor.hasError('minlength'))
      return "CNPJ inválido";

    if (this.f.frmCnpjEmpresa.hasError('required') ||
      this.f.frmCnpjFornecedor.hasError('required'))
      return 'CPNJ deve ser preenchido';
  }

  CancelarProtocolo() {
    let confirmCancel: boolean = false;
    let rtn: DocumentoPreEditadoRtn;

    //Validação de status
    if (this.modoEdicao) {
      if (this.protocoloEdicao.idStatusNovo == 9) {
        this.messageModel = new Message("Atenção", "Documento já cancelado, não é possível executar operação", "", "warning");
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }

      if (this.protocoloEdicao.idStatusNovo != 1 && this.protocoloEdicao.idStatusNovo != 4 && this.protocoloEdicao.idStatusNovo != 7) {
        this.messageModel = new Message("Atenção", "Não é possível realizar o cancelamento do protocolo para o status atual", "", "warning");
        this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
        return;
      }
    }

    //Validação do perfil de movimentação de protocolos de terceiros
    if ((this.currentUser.login != this.protocoloEdicao.loginResponsavel
      && !this.currentUser.movimentarProtocoloTerceiros)) {
      this.messageModel = new Message("Atenção", "Não é possível realizar o cancelamento de protocolos de terceiros", "", "warning");
      this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
      return;
    }

    this.messageModel = new Message("Atenção", "Ao confirmar a exclusão do protocolo, o mesmo será eliminado permanentemente. Deseja Continuar?", "", "confirm")
    const dialogRef = this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
    dialogRef.afterClosed().subscribe(result => {
      confirmCancel = result;

      if (confirmCancel) {
        this.loadComponent.startLoading(true);
        this.apiNaoFiscal.CancelarProtocoloNaoFiscal(this.CarregarDadosPreEditado())
          .subscribe(
            data => {
              rtn = data.data.result;

              if (rtn?.success) {
                this.messageModel = new Message("Atenção", "Protocolo cancelado com sucesso", "", "success");
                this.router.navigate(['/home']);
              }
              else {
                this.messageModel = new Message("Atenção", rtn.message, "", "warning");
              }
              
              this.dialog.open(PopupMessagesNewStyleTestComponent, { data: this.messageModel });
              this.loadComponent.startLoading(false);
            });
      }
    });
  }
}
